var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"title":_vm.title,"size":_vm.size,"hideFooter":""},on:{"hide":_vm.hide},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }